/* eslint-disable */
import { createContext } from 'react';

export const LogoutContext = createContext({
  logout: () => {
    console.error('no logout function found');
  },
});

export const UserContext = createContext({
  userName: undefined,
  roles: [],
  // we want to always return false until the roles have been populated.
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  haveRole: (requiredRoles: string[]): boolean => false,
} as {
  userName: string | undefined;
  roles: string[];
  haveRole: (requiredRoles: string[]) => boolean;
});

// The no-op is only the default for consumers rendered outside a provider.
export const ColorModeContext = createContext({ toggleColorMode: () => {} });
